import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import extend from 'lodash-es/extend';
import * as i1 from '@wdpr/ra-angular-logger';
import { LoggerModule } from '@wdpr/ra-angular-logger';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { switchMap, catchError, map, EMPTY } from 'rxjs';

class FeatureToggleExtenderService {
    constructor(logger) {
        this.logger = logger;
    }
    extendStateConfig(featureName, toggles, stateConfig, additionsIfFeatureEnabled, additionsIfFeatureDisabled) {
        const toggleStatus = toggles[featureName];
        if (toggleStatus && additionsIfFeatureEnabled) {
            extend(stateConfig, additionsIfFeatureEnabled);
        }
        else if (!toggleStatus && additionsIfFeatureDisabled) {
            extend(stateConfig, additionsIfFeatureDisabled);
        }
        else {
            this.logger.error(`extendStateConfig - ${toggles}[${featureName}] is not a boolean or additions to the config was not supplied`);
        }
        if (stateConfig && additionsIfFeatureDisabled) {
            this.logger.error('extendStateConfig - featureName, Toggles Map or state was not supplied');
            extend(stateConfig, additionsIfFeatureEnabled);
        }
        return stateConfig;
    }
    addState(featureName, toggles, statesArray, stateToBeAdded) {
        const toggleStatus = toggles[featureName];
        if (toggleStatus && statesArray && stateToBeAdded) {
            statesArray.push(stateToBeAdded);
        }
        else {
            this.logger.error(`addState - ${toggles}[${featureName}] is not a boolean or config
                             to be added or the state array was not supplied.`);
        }
    }
}
FeatureToggleExtenderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleExtenderService, deps: [{ token: i1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
FeatureToggleExtenderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleExtenderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleExtenderService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.LoggerService }]; } });

const FEATURE_TOGGLE_CONFIG = 'FEATURE_TOGGLE_CONFIG';

class FeatureToggleService {
    constructor(config, featureToggleExtender, http, logger) {
        this.config = config;
        this.featureToggleExtender = featureToggleExtender;
        this.http = http;
        this.logger = logger;
        this.featureToggleUrl = '/api/v1/toggles';
        this.appTogglesName = 'appToggles';
        this.featureToggleUrl = config.featureToggleUrl || this.featureToggleUrl;
        this.appTogglesName = config.appTogglesName || this.appTogglesName;
    }
    getToggles(featureSet, iterator) {
        return this.getFeatures(featureSet).pipe(switchMap((features) => {
            return this.addContext(featureSet, features, iterator);
        }), catchError(catchError(this.rejectToggleRequest.bind(this))));
    }
    getFeatures(featureSet) {
        const url = `${this.featureToggleUrl}/${featureSet}`;
        return this.http.get(url, { withCredentials: true }).pipe(map((response) => {
            return response;
        }), catchError(catchError(this.retrieveFeatureError.bind(this))));
    }
    retrieveFeatureError(error) {
        this.logger.error(`'Internal Error- Get Features,  Error Details:' ${error.message}`, error);
        return EMPTY;
    }
    rejectToggleRequest(error) {
        this.logger.error(`'Internal Error- Get Features,  Error Details:' ${error.message}`, error);
        return EMPTY;
    }
    addContext(featureSet, features, iterator) {
        // Fills the context for each feature based on the iteration function provided
        if (iterator) {
            features.forEach((feature) => iterator(feature));
        }
        else {
            this.logger.log('No context attached for features');
        }
        return this.getFeatureToggles(featureSet, features);
    }
    getFeatureToggles(featureSet, featuresWithContext) {
        const url = `${this.featureToggleUrl}/${featureSet}`;
        return this.http
            .post(url, featuresWithContext, {
            withCredentials: true,
        }).pipe(catchError((error) => {
            this.logger.error(`'Internal Error- Get Features,  Error Details:' ${error.message}`, error);
            return EMPTY;
        }));
    }
    addState(featureName, statesArray, statesToBeAdded) {
        this.featureToggleExtender.addState(featureName, this.appTogglesName, statesArray, statesToBeAdded);
    }
    extendStateConfig(featureName, stateConfig, additionsIfFeatureEnabled, additionsIfFeatureDisabled) {
        this.featureToggleExtender.extendStateConfig(featureName, this.appTogglesName, stateConfig, additionsIfFeatureEnabled, additionsIfFeatureDisabled);
    }
    getPrefetchedToggles() {
        return this.appTogglesName;
    }
}
FeatureToggleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleService, deps: [{ token: FEATURE_TOGGLE_CONFIG }, { token: FeatureToggleExtenderService }, { token: i2.HttpClient }, { token: i1.LoggerService }], target: i0.ɵɵFactoryTarget.Injectable });
FeatureToggleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [FEATURE_TOGGLE_CONFIG]
                }] }, { type: FeatureToggleExtenderService }, { type: i2.HttpClient }, { type: i1.LoggerService }]; } });

class FeatureToggleModule {
}
FeatureToggleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FeatureToggleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleModule, imports: [CommonModule,
        HttpClientModule,
        LoggerModule] });
FeatureToggleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleModule, providers: [FeatureToggleService, FeatureToggleExtenderService], imports: [CommonModule,
        HttpClientModule,
        LoggerModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.1.5", ngImport: i0, type: FeatureToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        LoggerModule
                    ],
                    declarations: [],
                    providers: [FeatureToggleService, FeatureToggleExtenderService],
                    exports: []
                }]
        }] });

/*
 * Public API Surface of ra-angular-feature-toggle
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FEATURE_TOGGLE_CONFIG, FeatureToggleExtenderService, FeatureToggleModule, FeatureToggleService };
